import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { toWebpPath } from '../config/assets';

interface PictureImageProps extends Omit<BoxProps, 'component'> {
  src: string;
  alt: string;
  title?: string;
  width?: number;
  height?: number;
  loading?: 'eager' | 'lazy';
}

const PictureImage: React.FC<PictureImageProps> = ({
  src,
  alt,
  title,
  width,
  height,
  loading = 'lazy',
  sx,
  ...boxProps
}) => (
  <Box component="picture" sx={{ display: 'block', ...sx }} {...boxProps}>
    <source srcSet={toWebpPath(src)} type="image/webp" />
    <Box
      component="img"
      src={src}
      alt={alt}
      title={title ?? alt}
      loading={loading}
      decoding="async"
      width={width}
      height={height}
      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
    />
  </Box>
);

export default PictureImage;
